import io from 'socket.io-client';

let isEnv = 'dev'; // local dev stag

const getBackendBaseUrl = () => {
  if (isEnv === 'stag') {
    return 'https://odrappservicestag-b9bshma0hkgschdf.southindia-01.azurewebsites.net';
  }

  if (isEnv === 'dev') {
    return 'https://odrappservicedev-dkevaqfyadbnh8cs.southindia-01.azurewebsites.net';
  }

  return 'http://localhost:5001';
};

const sockets = io(isEnv === 'local' ? 'localhost:5001' : getBackendBaseUrl());

export function getBaseUrl() {
  return isEnv === 'local' ? 'http://localhost:3000' : isEnv === 'dev' ? 'https://odrdev.connectrix.in' : 'https://odrstag.connectrix.in';
}

// export function getOdrBaseUrl() {
//   return isEnv === 'dev' ? 'https://odr_adm_ai_dev.uneecopscloud.com/' : 'https://odr_adm_uat.uneecopscloud.com/';
// }

export function getOdrBaseUrl() {
  return isEnv === 'local' || isEnv === 'dev' ? 'https://odr_adm_ai_dev.uneecopscloud.com/' : 'https://odr_adm_uat.uneecopscloud.com/';
}
 
export function getAzureBaseUrl() {
  return isEnv === 'dev' ? 'https://odrvideocallapidev.azurewebsites.net/' : 'https://odrvideocallapistag.azurewebsites.net/';
}

export function getAzureRecordingBaseUrl() {
  return 'https://odrvideocallapistag.azurewebsites.net/';
}

export function getpInfoAdmin() {
  return isEnv === 'local' || isEnv === 'dev' ? '&uinfo=450|42|6|Suraj|0|Y' : '&uinfo=450|42|6|Suraj|0|Y';
}

export function getpInfo() {
  return isEnv === 'local' || isEnv === 'dev' ? '&uinfo=450|42|6|Indrajeet|0|Y' : '&uinfo=450|42|6|Indrajeet|0|Y';
}

export function getSoundStatus() {
  return true;
}

export function addChatThread() {
  return `${getBackendBaseUrl()}/api/chat/`;
}

export function getRoomApiUrl() {
  return `${getBackendBaseUrl()}/create-room`;
}

export function getSpeedTest() {
  return `${getBackendBaseUrl()}/api/speedtest/`;
}

export default sockets;
